import MapServiceModel from '@/models/MapServiceModel';
import doc             from '@widesk-core/decorators/doc';

/**
 * Opération custom `POST /imports/{id}/plan/layer-preview` : rend UN calque du plan, seul,
 * pour l'étape « calques à importer ».
 *
 * Appel : `setId(importId).save({ method: 'post', patchAttributes: { layer } })`.
 *
 * Le SVG renvoyé a un fond TRANSPARENT et une boîte pixel calée sur l'emprise du calque :
 * le dessin remplit l'image, quelle que soit l'échelle des autres calques du plan.
 */
@doc.path('/imports/{id}/plan/layer-preview')
export default class PlanLayerPreviewModel extends MapServiceModel {
	@doc.string declare svgDataUri: string;
	@doc.number declare width: number;
	@doc.number declare height: number;
}
